var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"getLabel"},[_c('img',{staticClass:"flowPathPicture",attrs:{"src":require("../../assets/images/home/label.png"),"alt":""}})])
}]

export { render, staticRenderFns }